export default __webpack_public_path__ + "static/media/g_wdt_c_4.060429a7.mp3";